import { Briefcase, FileText, IdCard, KeyRound, PhoneCall, type LucideIcon } from 'lucide-react'
import type { PersonelFormValues } from '../schemas/personelFormSchema'

export type FormTab = 'kisisel' | 'is' | 'iletisim' | 'belgeler' | 'panel'

export const FULL_ROW = 'sm:col-span-2 lg:col-span-3'

type Field = keyof PersonelFormValues

export const FORM_TABS: { value: FormTab; icon: LucideIcon; fields: Field[] }[] = [
  {
    value: 'kisisel',
    icon: IdCard,
    fields: ['foto_adi', 'ad', 'dogum', 'tckn', 'uyruk', 'cinsiyet', 'medeni', 'egitim_durumu', 'universite_id', 'mezun_bolum'],
  },
  {
    value: 'is',
    icon: Briefcase,
    fields: [
      'sicil',
      'durum',
      'departman_id',
      'pozisyon',
      'sube',
      'istihdam',
      'calisma_turu',
      'ise_giris',
      'calisma_baslangic',
      'calisma_bitis',
      'yonetici',
      'brut_maas',
      'maas_gecerlilik',
      'sigorta',
      'ortak',
      'ortaklik_payi',
      'emeklilik_tarihi',
      'emeklilik_notu',
    ],
  },
  {
    value: 'iletisim',
    icon: PhoneCall,
    fields: ['email', 'telefon', 'is_tel', 'il_id', 'ilce_id', 'adres', 'acil_ad', 'acil_yakinlik', 'acil_telefon', 'acil_email', 'acil_adres'],
  },
  { value: 'belgeler', icon: FileText, fields: ['belgeler'] },
  {
    value: 'panel',
    icon: KeyRound,
    fields: [
      'panel_erisim',
      'firma_email',
      'role_ids',
      'mailbox_assign',
      'mailbox_provider_id',
      'mailbox_secret',
      'mailbox_signature',
      'sifre_sifirla',
    ],
  },
]

export function errorCountByTab(errors: Partial<Record<string, unknown>>): Record<FormTab, number> {
  const out = { kisisel: 0, is: 0, iletisim: 0, belgeler: 0, panel: 0 }
  for (const tab of FORM_TABS) out[tab.value] = tab.fields.filter((f) => errors[f]).length
  return out
}

export function firstTabWithError(errors: Partial<Record<string, unknown>>): FormTab | undefined {
  return FORM_TABS.find((tab) => tab.fields.some((f) => errors[f]))?.value
}
